// NavigationBridge.tsx
import { setNavigate } from "common/navigation";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const NavigationBridge = () => {
  const navigate = useNavigate();

  useEffect(() => {
    setNavigate(navigate);
  }, [navigate]);

  return null;
};
